import React from 'react';

const SvgCloseEvolution = (props) => (
  <svg width={12} height={12} {...props}>
    <path
      fill="#e25d34"
      stroke="#F6DDD7"
      d="M7.414 6l3.536 3.536-1.414 1.414L6 7.414 2.464 10.95 1.05 9.536 4.586 6 1.05 2.464 2.464 1.05 6 4.586 9.536 1.05l1.414 1.414L7.414 6z"
    />
  </svg>
);

export default SvgCloseEvolution;
